export const getImage = (image: string) => {
	if(image.includes('http')) {
		return image;
	} else {
		return `${process.env.REACT_APP_API_URL}/${image}`;
	}
}